import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'

type StyledExtraDataWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'isPromo'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledExtraDataWrapper = styled.div<StyledExtraDataWrapperProps>`
  ${({ isPromo }) => {
    return css`
      position: absolute;
      display: grid;
      row-gap: 8px;
      justify-items: end;
      top: ${isPromo ? '18px;' : '8px'};
      right: ${isPromo ? '18px;' : '8px'};
    `
  }}
`

const ExtraDataWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isPromo } = useContext(StandardTeaserLayoutContext)
  return (
    <StyledExtraDataWrapper isPromo={isPromo}>
      {children}
    </StyledExtraDataWrapper>
  )
}

export default ExtraDataWrapper
